import { useQuery } from "@tanstack/react-query";
import { Phone, Mail, MapPin, MessageCircle, Instagram, Clock } from "lucide-react";
import Seo from "@/components/Seo";
import LeadForm from "@/components/LeadForm";
import { getSettings } from "@/lib/api";
import { useSettings, waLink, telLink } from "@/lib/site";

export default function Contact() {
  const settings = useSettings();
  const { data: s } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  const mapQuery = encodeURIComponent((s && s.map_query) || "Ankara");

  return (
    <>
      <Seo title="İletişim | Ankara Düğün Fotoğrafçısı"
        description="Ankara düğün fotoğrafçısı ile iletişime geçin. WhatsApp, telefon ve teklif formu ile hemen tarih alın. Ankara'nın tüm ilçelerine hizmet."
        path="/iletisim" />

      <section className="pt-28 sm:pt-32 lg:pt-40 pb-10 bg-[#0E0F10]">
        <div className="container-lux text-center max-w-2xl mx-auto">
          <span className="eyebrow justify-center">İletişim</span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#F7F2E8] mt-3">Bize ulaşın</h1>
          <p className="text-[#9A9387] mt-4">
            Tarihinizi alın, konseptinizi konuşalım. Formu doldurun ya da WhatsApp/telefon ile hemen yazın.
          </p>
        </div>
      </section>

      <section className="pb-24 bg-[#0E0F10]" data-testid="contact-page">
        <div className="container-lux grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div className="rounded-2xl bg-[#FBF7EF] p-6 sm:p-8 border border-black/5">
            <h2 className="font-display text-2xl text-[#141517] mb-1">Teklif Formu</h2>
            <p className="text-sm text-[#5B5F66] mb-5">En kısa sürede size dönüş yapıyoruz.</p>
            <LeadForm />
          </div>

          <div className="space-y-4">
            <div className="grid sm:grid-cols-2 gap-4">
              <a href={waLink(settings)} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-button"
                className="rounded-2xl border border-white/10 bg-[#141517] p-5 hover:border-[rgba(200,162,74,0.5)] transition-colors">
                <MessageCircle className="w-6 h-6 text-[#25D366]" />
                <div className="text-[#F7F2E8] font-semibold mt-3">WhatsApp</div>
                <div className="text-sm text-[#9A9387] mt-1">Anında yanıt</div>
              </a>
              <a href={telLink(settings)} data-testid="contact-call-button"
                className="rounded-2xl border border-white/10 bg-[#141517] p-5 hover:border-[rgba(200,162,74,0.5)] transition-colors">
                <Phone className="w-6 h-6 text-[#C8A24A]" />
                <div className="text-[#F7F2E8] font-semibold mt-3">Telefon</div>
                <div className="text-sm text-[#9A9387] mt-1">{settings.phone}</div>
              </a>
            </div>

            <div className="rounded-2xl border border-white/10 bg-[#141517] p-6 space-y-4">
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#C8A24A]" />
                <a href={`mailto:${settings.email}`} className="text-[#EDE7DA] hover:text-white">{settings.email}</a>
              </div>
              <div className="flex items-center gap-3">
                <Instagram className="w-5 h-5 text-[#C8A24A]" />
                <a href={settings.instagram} target="_blank" rel="noreferrer" className="text-[#EDE7DA] hover:text-white">Instagram</a>
              </div>
              <div className="flex items-center gap-3">
                <MapPin className="w-5 h-5 text-[#C8A24A]" />
                <span className="text-[#EDE7DA]">{settings.address}</span>
              </div>
              <div className="flex items-center gap-3">
                <Clock className="w-5 h-5 text-[#C8A24A]" />
                <span className="text-[#EDE7DA]">Her gün 09:00 - 21:00</span>
              </div>
            </div>

            <div className="rounded-2xl overflow-hidden border border-white/10">
              <iframe title="Harita" width="100%" height="260" loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${mapQuery}&output=embed`} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
